import { useHistory } from 'react-router-dom'

import { isProduction } from '../../settings'
import { useEventTracker } from 'mmfintech-checkout-commons'
import { isMobileDevice, redirectToExternalUrl } from 'mmfintech-commons'

import { PreviewPix } from './PreviewPix'
import { PreviewFrame } from './PreviewFrame'
import { PreviewCrypto } from './PreviewCrypto'
import { PreviewMessage } from './PreviewMessage'
import { PreviewBankwire } from './PreviewBankwire'
import { PreviewInstructions } from './PreviewInstructions'

import type { PaymentResultType } from 'mmfintech-checkout-commons/types'

export const DepositResult = ({ response, session, sessionId }) => {
  const { result, resultType, processingAmount, status } = response || {}

  const history = useHistory()

  const { trackEvent } = useEventTracker()

  if (status === 'FAIL') {
    history.push('/fail')
    return
  }

  const redirectToProvider = () => {
    void trackEvent(sessionId, 'redirected_to_provider')
    redirectToExternalUrl(result)
  }

  switch (resultType as PaymentResultType) {
    case 'MESSAGE':
      return <PreviewMessage result={result} />

    case 'INSTRUCTIONS':
      return <PreviewInstructions result={result} session={session} sessionId={sessionId} />

    case 'REDIRECT_URL':
      redirectToProvider()
      return null

    case 'BANKWIRE_DETAILS':
      return <PreviewBankwire result={result} session={session} sessionId={sessionId} />

    case 'QR_CODE':
      return <PreviewPix value={result} />

    case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS': {
      const { returnUrl } = session || {}
      return <PreviewCrypto sessionId={sessionId} data={{ ...result, ...{ processingAmount }, returnUrl }} />
    }

    case 'IFRAME_URL':
      if (isMobileDevice()) {
        redirectToProvider()
      } else {
        trackEvent(sessionId, 'open_provider_in_frame')
        return <PreviewFrame url={result} />
      }
      return null

    default:
      if (!isProduction && resultType) {
        console.log(`DepositResult: Unknown result type "${resultType}"`)
      }
  }

  if (status === 'SUCCESS') {
    history.push('/success')
  }

  return null
}
